function redirectToPage(url: string): void {
  window.location.replace(url);
}

export default redirectToPage;
